// src/redux/reducers/menuManageReducer.js
import { combineReducers } from 'redux'
import orderHistorySlice from '../slice/order-history-slice/order-history-slice'

const orderHistoryReducer = combineReducers({
  orderHistory: orderHistorySlice
})

export default orderHistoryReducer
